export default __webpack_public_path__ + "static/Flying_Cow-e5e358df4bd8f71914b19f00f5cdbe2a.gif";